// extracted by mini-css-extract-plugin
export default {"partyFormLabel":"partyFormLabel---YFr8Q","endOfList":"endOfList---ZAHie"};